import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row } from 'react-bootstrap';
import FormBusca from './form_busca';
import LicService from '../../../services/licitacao'
import Licitacao from './lic';
import Moment from 'moment';
import Botoes from './botoes'


const ListarLicitacoes = () => {

    Moment.locale('pt');
    Moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ]
    });

    const [licitacao, setLicitacao] = useState([]);
    const [vazio, setVazio] = useState(false);
    const [ano, setAno] = useState("");
    const pathName = window.location.pathname;

    const getTipo = (path) => {
        switch (path) {
            case '/transparencia/licitacao/expomacuco/2025':
                setAno("2025");
                return { ano: "2025", service: LicService.buscarExpo };
            case '/transparencia/licitacao/expomacuco/2024':
                setAno("2024");
                return { ano: "2024", service: LicService.buscarExpo };
            case '/transparencia/licitacao/expomacuco/2023':
                setAno("2023");
                return { ano: "2023", service: LicService.buscarExpo };
            case '/transparencia/licitacao/expomacuco/anteriores':
                return { ano: null, service: LicService.buscarExpoAnt };
            default:
                return { ano: null, service: null };
        }
    };

    async function fetchLicitacaoIn() {
        const { ano, service } = getTipo(pathName);

        if (!service) {
            setLicitacao([]);
            setVazio(true);
            return;
        }

        try {
            const response = await service(ano ? { ano: ano } : {});
            if (response.data.length >= 1) {
                setLicitacao(response.data);
                setVazio(false);
            } else {
                setLicitacao([]);
                setVazio(true);
            }
        } catch (error) {
            console.error("Erro ao buscar Licitacao:", error);
            setLicitacao([]);
            setVazio(true);
        }
    }


    useEffect(() => {
        fetchLicitacaoIn();
    }, [window.location.pathname]);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setLics={setLicitacao}
                    setVazio={setVazio}
                    fetchLicsIn={fetchLicitacaoIn}
                    lics={licitacao}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Botoes />

            </Fragment> :
                <Fragment>
                    <Row xs={1}>
                        {licitacao.map((lic, index) =>
                            <Licitacao
                                lic={lic}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarLicitacoes;